import React, { useEffect } from 'react';
import { Check } from 'lucide-react';
import { TRIAL_PLAN, TRIAL_DAYS, usePlans, money } from '../plans';
import { SITE_URL } from '../siteConfig';
import { setJsonLd } from '../seo';

const ProPrice = ({ plans }) => {
  if (plans.status === 'loading') return <p className="mk-plan-price"><span className="mk-skel mk-skel-line" aria-label="Loading price" /></p>;
  if (plans.status === 'error') return <p className="mk-plan-price"><small>Current price shown at checkout</small></p>;
  return (
    <p className="mk-plan-price" data-testid="plan-pro-price">
      <span className="mk-num">{money(plans.monthly.price)}</span><small>/ month</small>
      {plans.yearly && <span className="mk-plan-alt">or <span className="mk-num">{money(plans.yearly.price)}</span> / year</span>}
    </p>
  );
};

const Plan = ({ name, badge, price, features, note, cta, onCta, featured, testId }) => (
  <li className={`mk-card mk-plan ${featured ? 'featured' : ''}`} data-testid={testId}>
    {badge && <span className="mk-plan-badge">{badge}</span>}
    <h3>{name}</h3>
    {price}
    <ul>{features.map((f) => <li key={f}><Check size={16} aria-hidden="true" /> {f}</li>)}</ul>
    {note && <p className="mk-fine">{note}</p>}
    <button type="button" className={`mk-btn mk-btn-block ${featured ? 'mk-btn-primary' : 'mk-btn-ghost'}`} onClick={onCta} data-testid={`${testId}-cta`}>{cta}</button>
  </li>
);

export const PlanCards = ({ onAuth }) => {
  const plans = usePlans();
  const proFeatures = plans.status === 'ready' ? plans.features : [];
  useEffect(() => {
    if (plans.status !== 'ready') return;
    setJsonLd('ld-software', {
      '@context': 'https://schema.org', '@type': 'SoftwareApplication', name: 'TradeHive AI', applicationCategory: 'FinanceApplication',
      operatingSystem: 'Web', url: `${SITE_URL}/`,
      description: 'AI-assisted research for stock and options traders. For research and educational purposes only; not investment advice.',
      offers: [plans.monthly, plans.yearly].filter(Boolean).map((p) => ({ '@type': 'Offer', name: p.name, price: Number(p.price).toFixed(2), priceCurrency: 'USD', description: `${TRIAL_DAYS}-day free trial available.` })),
    });
  }, [plans]);
  return (
    <ul className="mk-plans">
      <Plan name={TRIAL_PLAN.name} testId="plan-trial" features={TRIAL_PLAN.features} note={TRIAL_PLAN.note} cta="Start Free Trial" onCta={() => onAuth('signup')}
        price={<p className="mk-plan-price"><span className="mk-num">{TRIAL_PLAN.price}</span><small>{TRIAL_PLAN.period}</small></p>} />
      <Plan name={plans.monthly?.name?.replace(/ Monthly$/, '') || 'TradeHive Pro'} badge="Recommended" featured testId="plan-pro" features={proFeatures}
        price={<ProPrice plans={plans} />} cta="Start with Pro" onCta={() => onAuth('signup')} />
    </ul>
  );
};
